<template>
  <div class="not-found">
    <div class="top">
      如需帮助，欢迎致电客服热线 <a href="tel:4009-555-888">4009-555-888</a>
    </div>
    <div class="content">
      <div class="logo"><img
          src="../assets/images/codeImg.png"
          alt=""
        ></div>
      <div class="line1">
        此次活动仅限部分香奈儿尊享会员
      </div>
      <div class="line2">
        敬请期待未来更多精彩活动
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted () {

  }
}
</script>
<style lang="stylus" scoped>
.not-found
  text-align center
  width 100%
  height 100%
  display flex
  flex-direction column
  .top
    font-size 14px
    color #666
    padding 10px 0
    a
      color #666
  .content
    flex 1
    display flex
    justify-content center
    align-items center
    flex-direction column
  .logo
    width 60px
    height 60px
    margin 0 auto
    border 1px solid #000
    border-radius 100%
    overflow hidden
    margin-bottom 20px
    img
      max-width 100%
  .line1, .line2
    font-size 14px
    line-height 20px
</style>

